import { GoCalendar } from "react-icons/go"
import { formatDate } from "../../utils/formatDate"
import { FaMapMarkerAlt, FaShareAlt } from "react-icons/fa";
import { timeAgo } from "../../utils/time_ago";
import img from '../../assets/86.png'
import { Link } from "react-router-dom"

interface propTypes {
    data: any,
}

export const truncateText = (text: string, maxLength: number) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};


const FlashCard = ({ data }: propTypes) => {
    const mainThumbnail = data.images && data.images.length > 0
        ? data.images[0].thumbnail_url || data.images[0].image_url
        : null;

    return (
        <Link to={`/flash-alerts/${data?.id}`}>

            <div className="shadow-sm flex flex-col sm:flex-row overflow-hidden transition-all duration-200 hover:shadow-md cursor-pointer rounded-lg">
                {/* Thumbnail */}
                <div className="flex items-center justify-center sm:pl-4 pr-2 py-2 flex-shrink-0">
                    <div className="w-full sm:w-24 h-40 sm:h-20 overflow-hidden rounded-md">
                        <img
                            src={mainThumbnail}
                            alt={data.title}
                            className="w-full h-full object-cover object-top rounded-md"
                        />
                    </div>
                </div>

                {/* Content */}
                <div className="p-3 sm:p-4 flex-1 flex flex-col justify-between min-w-0">
                    {/* Title + Time */}
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-1 min-w-0">
                        <h3 className="text-base sm:text-lg font-semibold text-[#1F2937] truncate">
                            {truncateText(data.title, 40)}
                        </h3>
                        <span className="text-xs text-[#9CA3AF] mt-1 sm:mt-0 whitespace-nowrap flex-shrink-0">
                            {timeAgo(data.updated_at)}
                        </span>
                    </div>

                    {/* Description */}
                    <p className="text-[#4B5563] text-sm overflow-hidden text-ellipsis line-clamp-2 my-2">
                        {truncateText(data.description, 140)}
                    </p>

                    {/* Footer: Location + Date + Share */}
                    <div className="flex flex-wrap justify-between items-center text-xs text-[#6B7280] mt-3 sm:divide-x sm:divide-[#D1D5DB]">
                        {/* Location */}
                        <div className="flex items-center gap-1 flex-[1_1_50%] justify-center sm:flex-1 sm:justify-center mb-2 sm:mb-0">
                            <FaMapMarkerAlt className="text-[#6B7280]" size={12} />
                            <span className="font-medium truncate text-center sm:text-left">
                                {data.location}
                            </span>
                        </div>

                        {/* Date */}
                        <div className="flex items-center gap-1 flex-[1_1_50%] justify-center sm:flex-1 sm:justify-center mb-2 sm:mb-0 sm:px-3">
                            <GoCalendar className="text-[#6B7280]" size={12} />
                            <span className="font-medium text-center sm:text-left">
                                {formatDate(data.date)}
                            </span>
                        </div>

                        {/* Share */}
                        <div className="flex items-center gap-1 flex-[1_1_100%] justify-center sm:flex-1 sm:justify-center cursor-pointer hover:text-gray-900 transition-colors">
                            <FaShareAlt className="text-[#6B7280]" size={12} />
                            <span className="font-medium text-center sm:text-left">Share</span>
                        </div>
                    </div>
                </div>
            </div>

        </Link>
    )
}

export default FlashCard